import { useMutation } from "@shared/lib/hooks";
import { IBrandBilling } from "@shared/lib/types/brandBilling";
import { BILLING_TYPE, ORGANISATION_LIST_QUERY_KEY } from "../constants";
import { OrganisationService } from "../services/organisation.service";

export function useCreateInitialBilling(brandOrganisationId: string) {
  const {
    mutate: create,
    isLoading: isCreating,
    isSuccess: isCreated,
    error: createInitialBillingError,
    variables,
  } = useMutation({
    mutationFn: (payload: {
      brandOrganisationId: string;
      billingMode: BILLING_TYPE;
      brandBillingDetails: IBrandBilling[];
    }) => OrganisationService.createInitialBilling(payload),
    options: {
      skipInvalidation: true,
    },
    onSuccess: (c) => {
      c.invalidateQueries({
        queryKey: [...ORGANISATION_LIST_QUERY_KEY, brandOrganisationId],
      });
    },
  });

  return {
    create,
    isCreating,
    isCreated,
    createInitialBillingError,
    variables,
  };
}
